import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LegalDisclosure from "@/components/LegalDisclosure";

const PageShell = ({
  children,
  showOrbs = true,
  topPadding = true,
  hideNavbarAtTop = false,
  navyTheme = false,
  showFooter = true,
}) => {
  const bg = navyTheme
    ? "#071A35"
    : "radial-gradient(1200px 600px at 10% -10%, #EFE7FF 0%, transparent 60%), radial-gradient(900px 500px at 100% 10%, #DDF6EA 0%, transparent 55%), linear-gradient(180deg, #FAF7FF 0%, #F5F0FF 100%)";
  return (
    <div
      className="relative min-h-screen overflow-x-hidden"
      style={{ background: bg }}
    >
      {showOrbs && !navyTheme && (
        <>
          <div className="sn-bg-orbs">
            <div className="sn-orb sn-orb-a" />
            <div className="sn-orb sn-orb-b" />
            <div className="sn-orb sn-orb-c" />
          </div>
          <div className="sn-grid-overlay" />
        </>
      )}
      <Navbar hideAtTop={hideNavbarAtTop} darkTheme={navyTheme} />
      <main className={`relative z-10 ${topPadding ? "pt-28" : "pt-0"}`}>
        {children}
      </main>
      {showFooter && <Footer navyTheme={navyTheme} />}
      <LegalDisclosure />
    </div>
  );
};

export default PageShell;
